import { parsePhoneForApi, validatePhoneValue } from "@/utils/phoneInput";

export const REVIEW_SECTION_TYPE = {
  Holiday: 1,
  Activity: 2,
  Staycation: 3,
  Visa: 4,
  Hotel: 5,
  Stays: 5,
  CountryCityPage: 6,
  SeasonalDealsPage: 7,
};

export function getReviewSectionType(moduleType) {
  return REVIEW_SECTION_TYPE[moduleType] ?? 0;
}

export const MAX_REVIEW_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export function isReviewSuccess(response) {
  if (!response) return false;
  const status = String(response.status || response.Status || "").toLowerCase();
  return status === "success";
}

export function getReviewResponseMessage(response, fallback = "") {
  return (
    response?.message ||
    response?.Message ||
    response?.data?.message ||
    fallback
  );
}

export function getOversizedReviewFiles(files = []) {
  return files.filter((file) => file.size > MAX_REVIEW_FILE_SIZE_BYTES);
}

export function validateReviewFiles(photos = [], videos = []) {
  const oversized = getOversizedReviewFiles([...photos, ...videos]);
  if (!oversized.length) return "";

  const hasImage = oversized.some((file) => file.type.startsWith("image/"));
  const hasVideo = oversized.some((file) => file.type.startsWith("video/"));

  if (hasImage && hasVideo) {
    return "Image and video size should not exceed 5 MB.";
  }
  if (hasVideo) {
    return "Video size should not exceed 5 MB.";
  }
  return "Image size should not exceed 5 MB.";
}

export function validateReviewForm({
  userName,
  emailId,
  phone,
  rating,
  description,
  recommend,
  moduleType,
}) {
  const errors = {};

  if (!userName?.trim()) {
    errors.userName = "Please enter your name.";
  }

  const phoneError = validatePhoneValue(phone);
  if (phoneError) {
    errors.phone = phoneError;
  }

  if (!emailId?.trim()) {
    errors.emailId = "Please enter your email.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailId.trim())) {
    errors.emailId = "Please enter a valid email address.";
  }

  if (!rating) {
    errors.rating = "Please give a rating.";
  }

  if (!description?.trim()) {
    errors.description = "Please write your experience.";
  }

  if (recommend === null || recommend === undefined) {
    errors.recommend = "Please select whether you recommend this experience.";
  }

  if (!getReviewSectionType(moduleType)) {
    errors.moduleType = "Please select a module.";
  }

  return errors;
}

export function buildReviewFormData({
  userName,
  emailId,
  phone,
  moduleType,
  slug,
  rating,
  description,
  recommend,
  photos = [],
  videos = [],
}) {
  const formData = new FormData();

  formData.append("ReviewId", 0);
  formData.append("UserName", userName.trim());
  formData.append("EmailId", emailId.trim());
  formData.append("ReviewSectionType", getReviewSectionType(moduleType));
  formData.append("ReviewedOn", new Date().toISOString());
  formData.append("Rating", rating);
  formData.append("ReviewText", description.trim());
  formData.append("WouldYouRecommend", recommend);
  formData.append("Slug", slug || "");

  const parsedPhone = parsePhoneForApi(phone);
  if (parsedPhone) {
    formData.append("CountryCode", parsedPhone.countryCode);
    formData.append("MobileNumber", parsedPhone.phoneNo);
  }

  if (photos.length > 0) {
    formData.append("userImage", photos[0]);
  } else if (videos.length > 0) {
    formData.append("userImage", videos[0]);
  } else {
    formData.append("userImage", "");
  }

  photos.forEach((file) => {
    formData.append("reviewImages", file);
  });

  videos.forEach((file) => {
    formData.append("reviewImages", file);
  });

  return formData;
}
